import { z } from 'zod';

import { endDateAfterStartDate } from '@/shared/validation/zod-refines';

export function createProjectFormSchema({
  projectNameError,
  endDateError,
}: {
  projectNameError: string;
  endDateError: string;
}) {
  return z
    .object({
      projectName: z.string().min(1, { message: projectNameError }),
      projectDescription: z.string().optional(),
      startDate: z.date().optional(),
      endDate: z.date().optional(),
    })
    .refine(endDateAfterStartDate, {
      message: endDateError,
      path: ['endDate'],
    });
}
